import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getWorkPprAvailableColumns } from './api';

export const path = '/ppr/work/list';

const PageWorksPpr: React.FC = (props) => {
  const WorksPpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getWorkPprAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <WorksPpr {...props} />;
};

export default PageWorksPpr;
